import React, { useState, useEffect } from "react";

import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import "./Dashboard.scss";

//service
import api from "../../services/api";

// pages
import Overview from './Overview/Overview';
import Members from './Members/Members';
import Events from './Events/Events';
import SubjectsDashboard from './Subjects/Subjects';

const AntTabs = withStyles({
  root: {
    borderBottom: '0.5px solid #C7C7C7',
  },
  indicator: {
    backgroundColor: '#071FC1',
  },
})(Tabs);

const AntTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontSize: '22px',
    fontFamily: 'Open Sans',

    '&:hover': {
      color: '#071FC1',
      opacity: 1,
      fontWeight: theme.typography.fontWeightRegular,
    },
    '&$selected': {
      color: '#071FC1',
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  selected: {},
}))(props => <Tab disableRipple {...props} />);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles(theme => ({
  tabsHeader: {
    backgroundColor: theme.palette.background.paper,
  }
}));

function Dashboard({ communityList }) {

  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);
  const [eventId, setEventId] = useState(undefined);
  const [showLoading, setShowLoading] = useState(false);
  const [dataCommunity, setdataCommunity] = useState();
  const [dataEvents, setdataEvents] = useState();


  const getDataDashBoard = async () => {
    if (eventId) {
      setShowLoading(true)
      await api
        .get(`/getdashBoardOverview/`, { params: { id: eventId } })
        .then((res) => {
          setdataCommunity(res.data)
          setShowLoading(false)
        })
        .catch((err) => {
          setShowLoading(false)
          console.log(err)
        });
    }
  };

  const getDataEvents = async () => {
    if (eventId) {
      setShowLoading(true)
      await api
        .get(`/getdashBoardEvents/`, { params: { id: eventId } })
        .then((res) => {
          setShowLoading(false)
          setdataEvents(res.data)
        })
        .catch((err) => {
          setShowLoading(false)
          console.log(err)
        });
    }
  };

  useEffect(() => {
    if (eventId) {
      if (tabValue === 0) getDataDashBoard();
      if (tabValue === 2) getDataEvents();
    }
    return () => { }
  }, [eventId, tabValue]);

  useEffect(() => {
    setShowLoading(true)
    if (communityList.length > 0) {
      setEventId(communityList[0].id);
    } else {
      setShowLoading(false);
    }
    return () => { }
  }, [communityList]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className="dashboard-container">
      {showLoading && <div class="loader" />}
      <span className="title-dashboard">Dashboard</span>
      <div className="tabs-header">
        <div className="app-tabs">
          <div className={classes.tabsHeader}>
            <AntTabs value={tabValue} onChange={handleChange}>
              <AntTab label="Overview" />
              <AntTab label="Disciplinas" />
              <AntTab label="Membros" />
              <AntTab label="Eventos" />
            </AntTabs>
          </div>
          <div className="tabs-select">
            <select className="community-selected"
              onChange={event => setEventId(event.target.value)}
            >
              {communityList.map(community => <option value={community.id}>{community.title}</option>)}
            </select>
          </div>
        </div>

        <TabPanel value={tabValue} index={0}>
          <Overview
            tags={dataCommunity?.tags}
            totalAttenders={dataCommunity?.totalAttenders}
            connections={dataCommunity?.connections}
            eventId={eventId}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <SubjectsDashboard
            eventId={eventId}
            attenders={dataCommunity?.attender}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <Members attenders={dataCommunity?.attender} />
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <Events events={dataEvents} />
        </TabPanel>
      </div>
    </div>
  );
}

export default Dashboard;
